import styled from 'styled-components';

export const StyledColorCard = styled.div`
  padding: 2.5rem 1.1rem;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  color: white !important;
  width: 312px;
  gap: 18px;

  h3 {
    font-weight: 700;
    font-size: 32px;
    line-height: 35px;
  }

  p {
    font-weight: 200;
    font-size: 22px;
    line-height: 25px;
    color: white;
    margin: 0;
  }

  &.background-blue {
    background-color: #0000ff;
  }
  &.background-red {
    background-color: #e51f1e;
  }
  &.background-purple {
    background-color: #730893;
  }
`;
